import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import { showToast } from "services/utils/Status";
import { useSelector } from "react-redux";
import SelectDomainImg from "../../../assets/img/brand/SelectDomain.png";
import LoginLogo from "../../../assets/img/brand/organflow 2.0 logo.png";
import { userManagementError } from "services/constants/ErrorMessages";
import { Loader } from "components/Loader";
import SearchIcon from "@mui/icons-material/Search";

const keys = ["domain_name", "firm_name"];

export const ChangeDomain = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [tenantDetails, setTenantDetails] = useState([]);
  const { domain, userDetails } = useSelector((state) => state.tokenReducer);
  const [loading, setLoading] = useState(true);
  const [globalSearchValue, setGlobalSearchValue] = useState("");
  const [searchTenatDetails, setSearchTenatDetails] = useState([]);

  useEffect(() => {
    const getTenantDetails = async () => {
      let url = localStorage.getItem("LoginTag")
        ? `${domain}user_tenant/details/?email=${userDetails?.email}`
        : `${domain}user_tenant/details/?phone_number=${userDetails?.phonenumber}`;
      const userResponse = await fetch(url, {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      });
      const resData = await userResponse.json();
      if (userResponse?.ok) {
        setTenantDetails(resData);
        setLoading(false);
      } else {
        showToast("error", resData?.error);
      }
    };
    getTenantDetails();
  }, [domain, userDetails?.email, userDetails?.phonenumber]);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigateToDomain = (row) => {
    let domainUrl = "";
    let domain_details = "";
    if (row.domain_name === "localhost" || row.domain_name === "127.0.0.1") {
      domainUrl = `http://${row.domain_name}:8000/api/`;
      domain_details = `http://${row.domain_name}:3000`;
    } else {
      domainUrl = `https://${row.domain_name}/api/`;
      domain_details = `https://${row.domain_name}`;
    }
    localStorage.clear();
    onSubmit(row, domainUrl, domain_details);
  };

  const onSubmit = async (data, domainUrl, domain_details) => {
    let LoginTag = localStorage.getItem("LoginTag");
    setLoading(true);
    let url =
      LoginTag === "Email"
        ? `${domainUrl}login/email_verfication/?email=${data.email}`
        : `${domainUrl}phone_verfication/?phone_no=${data.phonenumber}`;
    const emailResponse = await fetch(url, {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    });
    const emailReturnResponse = await emailResponse.json();
    if (
      emailResponse.status === 200 &&
      emailReturnResponse.user_status === "Active"
    ) {
      localStorage.clear();
      const userId = emailReturnResponse.user_id;
      const userResponse = await fetch(`${domainUrl}custom-token-auth/`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          username: emailReturnResponse.emailuser.username,
          password: data.tenant_password,
        }),
      });
      const userReturnResponse = await userResponse.json();
      if (userReturnResponse?.error) {
        showToast("error", userReturnResponse?.error);
      }
      if (userResponse.status === 200) {
        const userData = {
          id: userId,
          first_name: emailReturnResponse.emailuser.first_name,
          username: emailReturnResponse.emailuser.username,
          last_name: emailReturnResponse.emailuser.last_name,
          email: emailReturnResponse.emailuser.email,
          type: emailReturnResponse.type,
          phonenumber: emailReturnResponse.type.phonenumber,
          approver: emailReturnResponse.approver,
          teamlead: emailReturnResponse.teamlead,
          firmName: emailReturnResponse.firm_name,
          approver_id: emailReturnResponse.approver_id,
          image_url: emailReturnResponse.image_url,
          department_id: emailReturnResponse.department_id,
          department_name: emailReturnResponse.department_name,
          employee_id: emailReturnResponse.employee_id,
          designation: emailReturnResponse.designation,
        };
        localStorage.setItem("currentuser", JSON.stringify(userData));
        localStorage.setItem("token", userReturnResponse.token);
        localStorage.setItem("sessionToken", userReturnResponse.session_token);
        localStorage.clear();
        localStorage.setItem("currentScreen", "My Zone");
        localStorage.setItem("currentSubMenu", "Calendar");
        if (
          emailReturnResponse.role === "Team Lead" ||
          emailReturnResponse.role === "Team Lead"
        ) {
          let url =
            LoginTag === "Email"
              ? `${domain_details}/admin/teamzone/attendance?token=${encodeURIComponent(
                  userReturnResponse.token,
                )}&email=${data.email}`
              : `${domain_details}/admin/teamzone/attendance?token=${encodeURIComponent(
                  userReturnResponse.token,
                )}&ph_no=${data.phonenumber}`;
          window.location.href = url;
        } else {
          let url =
            LoginTag === "Email"
              ? `${domain_details}/admin/myzone/status?token=${encodeURIComponent(
                  userReturnResponse.token,
                )}&email=${data.email}`
              : `${domain_details}/admin/myzone/status?token=${encodeURIComponent(
                  userReturnResponse.token,
                )}&ph_no=${data.phonenumber}`;
          window.location.href = url;
        }
      }
    } else if (
      emailReturnResponse.exists === false ||
      emailResponse.status === 400
    ) {
      setLoading(false);
      showToast("error", emailReturnResponse.error);
    } else if (emailReturnResponse.user_status === "Inactive") {
      setLoading(false);
      showToast("error", userManagementError.emailReturnResponseError);
    }
  };

  useEffect(() => {
    if (tenantDetails?.length !== 0 || tenantDetails?.length === 0) {
      const filteredResults = tenantDetails?.filter((item) =>
        keys.some((key) =>
          item[key]
            ?.toString()
            .toLowerCase()
            .includes(globalSearchValue.toString().toLowerCase()),
        ),
      );
      setSearchTenatDetails(filteredResults);
    }
  }, [globalSearchValue, tenantDetails]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid
        container
        style={{
          overflowY: "hidden",
          height: "100vh",
          justifyContent: "center",
        }}
      >
        <Mui.Grid item xs={0} sm={0} md={6} lg={6}>
          <Mui.Paper style={{ height: "100%" }}>
            <Mui.Box
              component="img"
              src={SelectDomainImg}
              alt="Login"
              sx={{
                width: "100%",
                height: { xs: "0px", sm: "0px", md: "100%", lg: "100%" },
                objectFit: "cover",
              }}
            />
            <a href="https://stringconsultants.com/">
              <Mui.Box
                sx={{
                  position: "absolute",
                  left: "25%",
                  bottom: "0.2%",
                  transform: "translate(-50%, -50%)",
                  color: "white",
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                © 2024 String Consultants. All Rights Reserved
              </Mui.Box>
            </a>
          </Mui.Paper>
        </Mui.Grid>
        <Mui.Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: { xs: 1, sm: 1 } }}
        >
          <Mui.Paper style={{ height: "100%" }}>
            {/* <form onSubmit={handleSubmit(onSubmit)}> */}
            <Mui.Grid
              container
              justifyContent="flex-end"
              sx={{ paddingTop: 2, paddingRight: 2, paddingBottom: 2 }}
            >
              <img
                src={LoginLogo}
                alt="LoginLogo"
                style={{ height: "22%", width: "22%" }}
              />
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingLeft: 2.8 }}>
              <Mui.Card
                component="form"
                sx={{
                  p: "6px 6px",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <Mui.IconButton type="button" aria-label="search">
                  <SearchIcon />
                </Mui.IconButton>
                <Mui.InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search for your desired domain..."
                  inputProps={{
                    "aria-label": "Search for your desired domain...",
                  }}
                  value={globalSearchValue}
                  onChange={(e) => setGlobalSearchValue(e.target.value)}
                />
              </Mui.Card>
            </Mui.Grid>

            {/* </form> */}
            <Mui.Box
              sx={{
                overflowY: "auto",
                overflowX: "hidden",
                display: "flex",
                flexDirection: "column",
                paddingX: 2,
                height: { xs: "75vh", sm: "75vh", md: "75vh", lg: "80vh" },
                position: "relative",
                width: "100%",
                mt: 1,
              }}
            >
              <Mui.Stack>
                {searchTenatDetails?.length === 0 ? (
                  <Mui.TableRow sx={{ paddingTop: 2, paddingLeft: 2 }}>
                    <Mui.Alert severity="info">No data available</Mui.Alert>
                  </Mui.TableRow>
                ) : (
                  searchTenatDetails.map((row, index) => (
                    <Mui.Grid container sx={{ padding: 1 }}>
                      <Mui.Card
                        onClick={() => navigateToDomain(row)}
                        sx={{
                          minWidth: {
                            xs: parseInt(width) / 1.1,
                            sm: parseInt(width) / 1.1,
                            md: parseInt(width) / 2.1,
                            lg: parseInt(width) / 2.1,
                            xl: parseInt(width) / 2.1,
                          },
                          cursor: "pointer",
                          borderRadius: 2,
                          boxShadow: 3,
                          padding: 1,
                        }}
                        fullWidth
                      >
                        <Mui.CardContent>
                          <Mui.Typography
                            variant="h6"
                            sx={{ fontWeight: "bold" }}
                          >
                            {row.firm_name}
                          </Mui.Typography>
                          <Mui.Typography
                            variant="body1"
                            color="text.secondary"
                          >
                            {row.domain_name}
                          </Mui.Typography>
                        </Mui.CardContent>
                      </Mui.Card>
                    </Mui.Grid>
                  ))
                )}
              </Mui.Stack>
            </Mui.Box>
          </Mui.Paper>
        </Mui.Grid>
      </Mui.Grid>
    </React.Fragment>
  );
};
